import {LanguageSymbol} from '../enums';

export interface ILocale {
  lang: LanguageSymbol;
  data: any;
}
